import * as Sentry from "@sentry/browser";
import { batch } from "react-redux";
import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import firebase from "sweet-web/firebase";
import { authSuccess, resetAuth } from "../auth/actions";
import { GetBookings, GetPayments } from "../booking/actions";
import { resetBooking } from "../booking/actions";
import { GetChats } from "../chat/actions";
import { RootState } from "../index";
import { resetSearch } from "../search/actions";
import { GetUser, resetUser } from "../user/actions";
import { GetMyVenues, GetVenues, resetVenues } from "../venue/actions";
import {
  AppActionTypes,
  LOG_IN,
  LOG_OUT,
  RESET_APP,
  SYNC_FAILURE,
  SYNC_INIT,
  SYNC_SUCCESS,
  TOGGLE_MENU
} from "./types";

export const logIn = (): AppActionTypes => {
  return { type: LOG_IN };
};

export const logOut = (): AppActionTypes => {
  return { type: LOG_OUT };
};

export const resetApp = (): AppActionTypes => {
  return { type: RESET_APP };
};

export const syncInit = (): AppActionTypes => {
  return { type: SYNC_INIT };
};

export const syncSuccess = (): AppActionTypes => {
  return { type: SYNC_SUCCESS };
};

export const syncFailure = (error: Error): AppActionTypes => {
  return { type: SYNC_FAILURE, error };
};

export const toggleMenu = (open: boolean): AppActionTypes => {
  return { type: TOGGLE_MENU, open };
};

// async function
export const LogOut = () => (dispatch: any) => {
  batch(() => {
    dispatch(resetApp());
    dispatch(resetUser());
    dispatch(resetAuth());
    dispatch(resetBooking());
    dispatch(resetVenues());
    dispatch(resetSearch());
  });
  dispatch(Sync());
};

export const Sync = (): ThunkAction<
  Promise<Function>,
  RootState,
  null,
  Action<string>
> => async (dispatch, getState) => {
  const listeners: Function[] = [];
  try {
    dispatch(syncInit());

    listeners.push(
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          dispatch(authSuccess(user.uid));
        }
      })
    );

    const state = getState();

    await GetVenues()(dispatch, getState, null);

    if (state.app.loggedIn) {
      const userEntity = await GetUser()(dispatch, getState, null);
      if (userEntity.type === "VENUE" || userEntity.type === "ADMIN") {
        await GetMyVenues()(dispatch, getState, null);
      }
      const chatListener = await GetChats()(dispatch, getState, null);
      listeners.push(chatListener);
      const bookingListener = await GetBookings()(dispatch, getState, null);
      listeners.push(bookingListener);
      const paymentListener = await GetPayments()(dispatch, getState, null);
      listeners.push(paymentListener);
    }

    dispatch(syncSuccess());

    return () => {
      listeners.forEach(listener => {
        if (typeof listener === "function") listener();
      });
    };
  } catch (error) {
    Sentry.captureException(error);
    dispatch(syncFailure(error));
    // if sync failed, log out and try syncing again
    dispatch(LogOut());

    return () => {};
  }
};
